import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {WidgetListModalComponent} from '../widgets/widget-list-modal/widget-list-modal.component';
import {finalize} from 'rxjs/operators';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {BiolinkEditorService} from '../biolink-editor.service';
import {Toast} from '@common/core/ui/toast.service';
import {BiolinksService} from '../../biolinks.service';
import {Settings} from '@common/core/config/settings.service';
import {SKELETON_ANIMATIONS} from '@common/core/ui/skeleton/skeleton-animations';
import {BiolinkLink} from '../biolink-link';
import {BiolinkWidget} from '../widgets/biolink-widget';

@Component({
    selector: 'biolink-editor-content',
    templateUrl: './biolink-editor-content.component.html',
    styleUrls: ['./biolink-editor-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: SKELETON_ANIMATIONS,
})
export class BiolinkEditorContentComponent {
    skeletonIterator = Array(5);
    trackByFn = (i: number, item: BiolinkLink | BiolinkWidget) => item.id;

    constructor(
        private modal: Modal,
        public editor: BiolinkEditorService,
        private toast: Toast,
        private biolinks: BiolinksService,
        public settings: Settings
    ) {}

    openNewLinkDialog() {
        this.editor.openCrupdateLinkDialog(null, {
            createMsg: 'Link added',
        });
    }

    openWidgetListDialog() {
        this.modal.open(WidgetListModalComponent, {
            biolinkId: this.editor.biolink$.value.id,
        });
    }

    reorderContent(e: CdkDragDrop<any>) {
        if (e.previousIndex === e.currentIndex) return;
        const newContent = [...this.editor.biolink$.value.content];
        moveItemInArray(newContent, e.previousIndex, e.currentIndex);
        this.editor.biolink$.next({
            ...this.editor.biolink$.value,
            content: newContent,
        });

        const payload = newContent.map(c => {
            return {id: c.id, model_type: c.model_type};
        });

        this.editor.loading$.next(true);
        this.biolinks
            .changeOrder(this.editor.biolink$.value.id, payload)
            .pipe(finalize(() => this.editor.loading$.next(false)))
            .subscribe();
    }
}
